import { useQuery } from "react-query";
import { AreaComumRegrasReserva } from "../typings";
import http from "infra/http";

function useAreaComumRegrasReserva(areaComumId: string, tenantId: string | null) {
  return useQuery(`/v1/tenants/${tenantId}/area-comum/${areaComumId}/regras-reserva`, async () => {
    const { data } = await http.get<AreaComumRegrasReserva>(`/v1/tenants/${tenantId}/area-comum/${areaComumId}/regras-reserva`);

    return data;
  }, {
    enabled: !!areaComumId && !!tenantId
  });
}

export default useAreaComumRegrasReserva;
